import Navbar from './Navbar'
import React, { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { jwtDecode } from 'jwt-decode'
// import ObjectiveImg from '../../assets/objective.png';
// import FooterImg from '../../assets/footer.png';
import Carousel from './Carousel';
import Footer from './Footer';
// import FooterPage from './FooterPage';
// import Objective from './Objective';
import NVCTIFacilities from './Objective';
import RecentActivities from './RecentActivities';
import ServicesSection from './ServicesSection';
import AllEvent from './AllEvent';
import Think from './Think';
import CtaSection from './CtaSection';
import FancyBoxLayout4 from './Fancy';

const getToken = () => localStorage.getItem("token");

const isAuthenticated = () => {
  const token = getToken();
  if (!token) return false;
  try {
    const decoded = jwtDecode(token);
    const expired = decoded.exp * 1000 < Date.now();
    if (expired) {
      localStorage.clear();
      return false;
    }
    return true;
  } catch {
    return false;
  }
};

const getRole = () => {
  const token = getToken();
  if (!token) return null;
  try {
    return jwtDecode(token).role;
  } catch {
    return null;
  }
};

const HomePage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');

      const scrollToHash = () => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      };

      // Try scrolling immediately, then again bit later to account for image loads
      setTimeout(scrollToHash, 100);
      setTimeout(scrollToHash, 500);

    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  useEffect(() => {

    if (isAuthenticated()) {
      const userRole = getRole();

      switch (userRole) {
        case "student":
          navigate("/student/events");
          break;
        case "admin":
        case "office manager":
          navigate("/admin/events");
          break;
        default:

          console.warn("Unknown user role:", userRole);
          break;
      }
    }
  }, [navigate]);

  return (
    <>
      <Navbar />
      <Carousel />
      {/* <Objective /> */}
      <NVCTIFacilities />
      {/* <img
        src={ObjectiveImg}
        alt="Naresh Vashisht"
        className="max-h-[500px] object-contain"
      /> */}
      {/* <img
        src={FooterImg}
        alt="Naresh Vashisht"
        className="max-h-[500px] object-contain"
      /> */}
      <ServicesSection />
      <Think />
      <AllEvent />
      {/* <FancyBoxLayout4 /> */}
      {/* <CtaSection /> */}
      <RecentActivities />
      <Footer />
      {/* <FooterPage /> */}
    </>
  )
}

export default HomePage;